import apiServices from '../../../services/service';
import { toast } from 'react-toastify';

const UsersWithRMName = async (userList) => {
  try {
    // Call the API and await the response
    const response = await apiServices.getAssociateRM();

    if (response.status === 200) {
      // Perform operations once the API call is successful
      const finalUserList = userList?.map((user) => {
        const associateData = response.data?.associateRms?.find(
          (rm) => rm?.userId === user?.userId
        );
        return associateData ? { ...user, ...associateData } : user;
      });

      // Set RM name
      const finalDataWithRMName = finalUserList?.map((user) => {
        const rm = finalUserList?.find((r) => r?.userId === user?.rmId);
        return rm ? { ...user, rmName: rm?.display_name } : user;
      });

      // Return the final processed data
      return finalDataWithRMName;
    } else {
      // Handle non-200 status codes
      toast.error(`An unexpected error occurred: ${response.status}`, {
        position: 'top-right',
      });
      return response;
    }
  } catch (error) {
    // Catch and handle any errors
    toast.error('An unexpected error occurred.', {
      position: 'top-right',
    });
    console.error('Error occurred:', error);
  }
};

export default UsersWithRMName;
